const plugin = require('tailwindcss/plugin');

const scrollbarHide = plugin(function ({addUtilities}) {
  addUtilities({
    '.scrollbar-hide': {
      /* Firefox */
      'scrollbar-width': 'none',
      /* IE */
      '-ms-overflow-style': 'none',
      /* Safari and Chrome */
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  });
});

module.exports = scrollbarHide;
